__turbopack_context__.v({
  "wrapper": "index-module-scss-module__jaSJsa__wrapper",
});
